import { useTranslator } from '@bluebeam/react-i18n';
import {
  MapOverlayMachineEventsEnum,
  useMapOverlayMachine,
} from 'components/Overlays/MapOverlayMachine';
import OverlayHeader from 'components/Overlays/OverlayHeader';
import OverlayViewerContainer from 'components/Overlays/OverlayViewerContainer';
import React, { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { ViewRFI } from 'records/interactions/ViewRFI';
import { ViewRFIList } from 'records/interactions/ViewRFIList';
import { Markup } from 'records/Markup';
import { RFI } from 'records/RFI';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';
import RFIList from './RFIList';

type ViewRFIListProps = {
  interaction: ViewRFIList;
} & WithAppStoreProps;

const ViewRFIListOverlay: FC<ViewRFIListProps> = ({ interaction, actions }) => {
  const { mapOverlayMachineService } = useMapOverlayMachine();
  const location = useLocation();
  const { translate } = useTranslator(['mapView']);

  function handleCancelClick(): void {
    if (location.pathname.includes('map')) {
      mapOverlayMachineService.send(MapOverlayMachineEventsEnum.CLOSE_OVERLAY);
    } else {
      actions.clearInteractions();
    }
  }

  async function handleRFIListRowClick(
    rfi: RFI,
    markup: Markup
  ): Promise<void> {
    const viewRFIInteraction = new ViewRFI({
      rfi,
      markup,
      placing: true, // ?
      containerStyles: interaction.containerStyles,
    });

    if (location.pathname.includes('map')) {
      mapOverlayMachineService.send({
        type: MapOverlayMachineEventsEnum.OPEN_RFI_OVERLAY,
        data: { interaction: viewRFIInteraction },
      });
    } else {
      actions.clearInteractions();
      actions.createInteraction(viewRFIInteraction);
    }
  }

  return (
    <OverlayViewerContainer
      id="view-rfi-list-overlay"
      style={interaction.containerStyles}
    >
      <OverlayHeader
        id="view-rfi-list-overlay-header"
        title={translate('mapView:mapPageSubheader.rfis')}
        onCancelClick={handleCancelClick}
      />
      <RFIList onRFIListRowClick={handleRFIListRowClick} />
    </OverlayViewerContainer>
  );
};

export default withAppStore(ViewRFIListOverlay);
